module.exports = __webpack_public_path__ + "img/structure.1c2c7e74.png";